const updates = [
  { time: '10分钟前', title: '某顶流男星机场被拍到与神秘女子同行，疑似新恋情曝光', tag: '独家', tagColor: 'accent' },
  { time: '28分钟前', title: '知名综艺节目录制现场突发状况，导演组紧急叫停拍摄', tag: '快讯', tagColor: 'secondary' },
  { time: '1小时前', title: '网红带货翻车事件持续发酵，品牌方宣布终止全部合作', tag: '追踪', tagColor: 'primary' },
  { time: '2小时前', title: '某女星深夜发文疑似回应离婚传闻，字里行间信息量巨大', tag: '独家', tagColor: 'accent' },
  { time: '3小时前', title: '热门电视剧剧组内部矛盾曝光，男一号与导演关系破裂', tag: '快讯', tagColor: 'secondary' },
  { time: '4小时前', title: '娱乐圈再爆税务问题，知情人透露调查范围正在扩大', tag: '追踪', tagColor: 'primary' },
  { time: '5小时前', title: '某选秀出身偶像被曝私生活混乱，多名女子同时发声指控', tag: '独家', tagColor: 'accent' },
  { time: '6小时前', title: '知名音乐人涉嫌抄袭事件新进展，原作者正式提起诉讼', tag: '快讯', tagColor: 'secondary' },
  { time: '8小时前', title: '综艺节目剪辑争议升级，被剪嘉宾发文怒斥节目组不公', tag: '追踪', tagColor: 'primary' },
];

const tagColorMap: Record<string, string> = {
  accent: 'bg-accent-100 text-accent-700',
  secondary: 'bg-secondary-100 text-secondary-700',
  primary: 'bg-primary-100 text-primary-700',
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
            <i className="ri-flashlight-line text-background-50 text-xl"></i>
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">最新快讯</h2>
        </div>
        <p className="text-foreground-500 text-sm mb-8 md:mb-10 ml-13">实时追踪 · 黑料在线最新爆料动态一网打尽</p>

        <div className="relative pl-8 border-l-2 border-background-300 space-y-6">
          {updates.map((item, i) => (
            <div key={i} className="relative">
              <div className="absolute -left-[calc(2rem+5px)] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-50"></div>
              <div className="flex items-start gap-3 flex-wrap">
                <span className="text-xs text-foreground-500 whitespace-nowrap">{item.time}</span>
                <span className={`text-xs px-2 py-0.5 rounded-full font-medium whitespace-nowrap ${tagColorMap[item.tagColor]}`}>
                  {item.tag}
                </span>
              </div>
              <h3 className="text-sm md:text-base font-medium text-foreground-900 mt-1.5 hover:text-primary-600 transition-colors cursor-pointer">
                {item.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}